import AbstractNotification from "./AbstractNotification";
import {
  accept,
  cancelled,
  decline,
  declined,
  miss,
  stopped
} from "../../../../screens/video/actions/videoAction";
import {
  TW_ACTION_CANCEL,
  TW_ACTION_DECLINE,
  TW_ACTION_STOP,
  TW_VIDEO_TAG
} from "../../twilio/constants";
import {ROUTER_VIDEO} from "../../../constants/routers";
import {RC_USER_PREFIX_T} from "../constants";
import video_sound from "../../../../../assets/phone-ring.mp3";
import {videoIncoming} from "../../notification/actions/localAction";

export default class VideoCallNotification extends AbstractNotification {

  title = __("call");
  icon = 'fa-phone';
  sound = video_sound;

  constructor(notification, sender) {
    super(notification, sender);

    this.content = notification.text.replace(TW_VIDEO_TAG, '');
  }

  accept(dispatch, history) {
    dispatch(accept(this))
      .then(() => {
        history.push(ROUTER_VIDEO);
      });
  }

  isAtChatStream() {
    return false;
  }

  decline(dispatch) {
    dispatch(miss(this.room));
    dispatch(decline(this));
  }

  timeOut(dispatch) {
    this.decline(dispatch);
  }

  notify(dispatch, history) {
    videoIncoming(
      this.sender,
      this.title,
      () => {
        this.accept(dispatch, history)
      },
      () => {
        this.decline(dispatch)
      }
    )
  }

  static checkVideoActions(dispatch, notification) {
    if (notification.text.startsWith(TW_VIDEO_TAG) &&
      notification.payload.sender.username.includes(RC_USER_PREFIX_T)
    ) {
      switch (true) {
        case notification.text.endsWith(TW_ACTION_CANCEL):
          dispatch(cancelled(notification.payload.rid));
          break;
        case notification.text.endsWith(TW_ACTION_DECLINE):
          dispatch(declined());
          break;
        case notification.text.endsWith(TW_ACTION_STOP):
          dispatch(stopped());
          break;
        default:
          return true;
      }
      return false;
    }
    return true;
  }
}
